import React, { VFC } from "react";
import AmpQaFixedHeader from "~/components/modules/qaFixedHeader/AmpQaFixedHeader";
import QaFixedHeader from "~/components/modules/qaFixedHeader/QaFixedHeader";
import { composeShareUrlLine, composeShareUrlTwitter } from "~/lib/share";
import {
  generateQaDetailPath,
  getQaHostAndLocaleForURL,
} from "~/lib/utils/urlHelper";
import { Project } from "~/models/project";
import { QuestionAnswer } from "~/models/questionAnswer";
import { Topic } from "~/models/topic";

interface QaFixedHeaderContainerProps {
  filteredQuestionContent: string;
  increaseFeedbackHelpfulCallback?: () => void;
  increaseFeedbackHelpfulUrl?: string;
  isAmp?: boolean;
  isForceSP?: boolean;
  project: Project;
  questionAnswer: QuestionAnswer;
  topic: Topic;
  twitterAccount?: string;
  twitterTags?: string[];
}

const QaFixedHeaderContainer: VFC<QaFixedHeaderContainerProps> = ({
  filteredQuestionContent,
  increaseFeedbackHelpfulCallback,
  increaseFeedbackHelpfulUrl,
  isAmp,
  isForceSP,
  project,
  questionAnswer,
  topic,
  twitterAccount,
  twitterTags,
}) => {
  const { host, locale } = getQaHostAndLocaleForURL({
    isAbsolute: true,
    project,
    questionAnswer,
  });
  const url = {
    ...generateQaDetailPath({ questionAnswer, topicSlug: topic.slug }),
    host,
  };

  const twitterShareUrl = composeShareUrlTwitter({
    account: twitterAccount,
    hashTags: twitterTags,
    locale,
    shareText: questionAnswer.questionContent ?? "",
    url,
  });

  const lineShareUrl = composeShareUrlLine({
    locale,
    shareText: questionAnswer.questionContent ?? "",
    url,
  });

  return isAmp ? (
    <AmpQaFixedHeader
      filteredQuestionContent={filteredQuestionContent}
      increaseFeedbackHelpfulUrl={increaseFeedbackHelpfulUrl}
      lineShareUrl={lineShareUrl}
      questionAnswer={questionAnswer}
      topic={topic}
      twitterShareUrl={twitterShareUrl}
    />
  ) : (
    <QaFixedHeader
      filteredQuestionContent={filteredQuestionContent}
      increaseFeedbackHelpfulUrl={increaseFeedbackHelpfulUrl}
      increaseFeedbackHelpfulCallback={increaseFeedbackHelpfulCallback}
      isForceSP={isForceSP}
      lineShareUrl={lineShareUrl}
      questionAnswer={questionAnswer}
      topic={topic}
      twitterShareUrl={twitterShareUrl}
    />
  );
};

export default QaFixedHeaderContainer;
